import { render, staticRenderFns } from "./dashboard-app.vue?vue&type=template&id=15503151&scoped=true"
import script from "./dashboard-app.vue?vue&type=script&lang=js"
export * from "./dashboard-app.vue?vue&type=script&lang=js"
import style0 from "./dashboard-app.vue?vue&type=style&index=0&id=15503151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15503151",
  null
  
)

export default component.exports